export default "__VITE_ASSET__BJkQh5as__"